import React, { useEffect } from "react";
import dbFetch from "../../utils/dbFetch";
import Carousel from "../../components/elements/Carousel";
// import BgImg from '../../assets/img/edito_bg.png';

const { REACT_APP_EDITO_ID } = process.env;

export default function Edito() {
    let page = dbFetch(process.env.REACT_APP_API + "pages?parent=" + REACT_APP_EDITO_ID + "&_embed&filter[menu_order]=date&order=asc");

    return ( <>
        <h2 > <span className = "item1" > 2020</span> <span className="item2">vue par</span> <span className="item3">les dirigeantes de la Soreqa</span></h2> {
            page?.length > 0 && (
            <Carousel slidesPerView = "1" pagination paginationPrefix = 'question' autoheight >
              {
                    page && page.map((item, index) => {
                        const sousTitre = item.acf["sous-titre"] ? "<span>" + item.acf["sous-titre"] + "</span><br/>" : "";
                        let image = item?._embedded["wp:featuredmedia"] && item?._embedded["wp:featuredmedia"][0].media_details?.sizes.full?.source_url ? item._embedded["wp:featuredmedia"][0].media_details.sizes.full.source_url : null;

                        const { title, content } = item;
                        return ( <div key = { item.id } >
                            <div className = "swiper__inner" >
                              <h3 dangerouslySetInnerHTML = {
                                  {
                                      __html: title.rendered + sousTitre,
                                  }
                              }
                              />
                              <blockquote dangerouslySetInnerHTML={
                                  {
                                      __html: content.rendered,
                                  }
                              }
                              />
                            </div>
                          </div>
                        );

                        /*
                        return (
                            <div key={index} className="columns is-gapless mx-5">
                                <div className="column is-4-desktop is-12">
                                    <h3
                                        dangerouslySetInnerHTML={{
                                            __html: title.rendered + sousTitre,
                                        }}
                                    />
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: content.rendered,
                                        }}
                                    />
                                </div>
                                <div className="column is-12 is-6-desktop is-flex is-flex-direction-column is-justify-content-flex-end">
                                    {image !== null && (
                                        <img
                                            className="responsive-image edito__img"
                                            src={image}
                                            alt={
                                                process.env
                                                    .REACT_APP_DEFAULT_ALT
                                            }
                                        />
                                    )}
                                </div>
                            </div>
                        );
                        */
                    })
                }

              </Carousel>
            )
        }
            <div className="edito__bgImg"></div>
         </>
    );
}